import { Label, Message, Radio } from '@iwoca/orion';
import { clsx } from 'clsx';
import { useFormContext } from 'react-hook-form';

import { TCompanyDetailsDataUK } from './CompanyDetailsUK';
import companyDetailsStyles from './CompanyDetailsUK.module.css';

const VatRegisteredRadiosUK = () => {
  const {
    register,
    formState: { errors },
  } = useFormContext<TCompanyDetailsDataUK>();

  return (
    <>
      <Label className={companyDetailsStyles.formLabel}>
        Is the business VAT registered?
      </Label>
      <div className={companyDetailsStyles.radioOptions}>
        <Radio
          {...register('isVatRegistered')}
          wrapperClassName={clsx(companyDetailsStyles.radioOption, {
            [companyDetailsStyles.errorContainer]: errors.isVatRegistered,
          })}
          frame
          value="true"
          label="Yes"
        />
        <Radio
          {...register('isVatRegistered')}
          wrapperClassName={clsx(companyDetailsStyles.radioOption, {
            [companyDetailsStyles.errorContainer]: errors.isVatRegistered,
          })}
          frame
          value="false"
          label="No"
        />
      </div>
      {errors.isVatRegistered && (
        <Message
          className={companyDetailsStyles.vatErrorMessage}
          message={errors.isVatRegistered.message || ''}
          type="error"
        />
      )}
    </>
  );
};

export default VatRegisteredRadiosUK;
